import { render, staticRenderFns } from "./SalesOrderFilters.vue?vue&type=template&id=89be9660&"
import script from "./SalesOrderFilters.vue?vue&type=script&lang=js&"
export * from "./SalesOrderFilters.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderFilters.vue?vue&type=style&index=0&id=89be9660&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports